<template>
    <div class="dashboard-item dash_item">
      <div class="dashboard-item__arrow" v-show="!ordersListOpenLocal">
        <button class="dashboard-content__arrow dashboard-content__arrow-right" tabindex="0" type="button" @click="openItem()">
              <span class="dashboard-content__label dashboard-content__label-left">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" class="dashboard-content__img" focusable="false" style="transform: rotate(0deg);"><g><g>
                  <g>
                    <path d="M388.425 241.951L151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0014.057 5.835 19.79 19.79 0 0014.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z"></path>
                  </g>
                </g></g> </svg>
              </span>
        </button>
      </div>
      <div class="dashboard-content">
        <div class="dashboard-content__categories">

          <div class="dashboard-content__categories__item" v-for="(item, index) in servicesList" :key="index">
            <a :href="goToService(item.service_id)"
              v-tooltip="{content: item.service_title, placement: 'right-center'}"
              @mouseover="mouseOverItem(item.service_id)"
              @mouseleave="mouseLeaveItem()">
              <div class="dashboard-content__categories__item-img" :class="['service-active-' + item.service_id]" v-if="serviceName === item.service_id || hoveredItem === item.service_id">
                <img :src="getImgPath(item.service_id, true)" alt="">
              </div>
              <div class="dashboard-content__categories__item-img" v-else>
                <img :src="getImgPath(item.service_id)" alt="">
              </div>
            </a>
          </div>

          <!-- пока этого сервиса нет -->
          <!-- <div class="dashboard-content__categories__item">
            <a href="#">
              <div class="dashboard-content__categories__item-img">
                <img src="@img/forest-2.svg" alt="">
              </div>
            </a>
          </div> -->
          <!-- <div class="dashboard-content__categories__item">
            <a :href="goToService('eco')"
              v-tooltip="{content: 'Эко-мониторинг', placement: 'right-center'}"
              @mouseover="mouseOverItem('eco')"
              @mouseleave="mouseLeaveItem()">
              <div class="dashboard-content__categories__item-img service-active-eco" v-if="serviceName === 'eco' || hoveredItem === 'eco'">
                <img src="@img/eco-monitoring-active.svg" alt="">
              </div>
              <div class="dashboard-content__categories__item-img" v-else>
                <img src="@img/eco-monitoring.svg" alt="">
              </div>
            </a>
          </div>

          <div class="dashboard-content__categories__item">
            <a :href="goToService('quarry')"
              v-tooltip="{content: 'Карьеры', placement: 'right-center'}"
              @mouseover="mouseOverItem('quarry')"
              @mouseleave="mouseLeaveItem()">
              <div class="dashboard-content__categories__item-img service-active-quarry" v-if="serviceName === 'quarry' || hoveredItem === 'quarry'">
                <img src="@img/quarry-active.svg" alt="">
              </div>
              <div class="dashboard-content__categories__item-img" v-else>
                <img src="@img/quarry.svg" alt="">
              </div>
            </a>
          </div>

          <div class="dashboard-content__categories__item">
            <a :href="goToService('construction')"
              v-tooltip="{content: 'Строй-контроль', placement: 'right-center'}"
              @mouseover="mouseOverItem('construction')"
              @mouseleave="mouseLeaveItem()">
              <div class="dashboard-content__categories__item-img service-active-construction" v-if="serviceName === 'construction' || hoveredItem === 'construction'">
                <img src="@img/construction-active.svg" alt="">
              </div>
              <div class="dashboard-content__categories__item-img" v-else>
                <img src="@img/construction.svg" alt="">
              </div>
            </a>
          </div>

          <div class="dashboard-content__categories__item">
            <a :href="goToService('emergency')"
              v-tooltip="{content: 'Чрезвычайные ситуации', placement: 'right-center'}"
              @mouseover="mouseOverItem('emergency')"
              @mouseleave="mouseLeaveItem()">
              <div class="dashboard-content__categories__item-img service-active-emergency" v-if="serviceName === 'emergency' || hoveredItem === 'emergency'">
                <img src="@img/emergency-active.svg" alt="">
              </div>
              <div class="dashboard-content__categories__item-img" v-else>
                <img src="@img/emergency.svg" alt="">
              </div>
            </a>
          </div> -->

        </div>
      </div>
      <item-dashboards-subs v-show="ordersListOpen"/>
    </div>
</template>

<script>
import appStore from '@storages/appStore'
import adaptiveStore from '@storages/adaptiveStore'
import ItemDashboardSubs from '@/components/common/headerItems/ItemDashboardSubs'
// images
import ecoActiveImg from '@img/eco-monitoring-active.svg'
import ecoImg from '@img/eco-monitoring.svg'
import quarryActiveImg from '@img/quarry-active.svg'
import quarryImg from '@img/quarry.svg'
import constructionActiveImg from '@img/construction-active.svg'
import constructionImg from '@img/construction.svg'
import emergencyActiveImg from '@img/emergency-active.svg'
import emergencyImg from '@img/emergency.svg'
import legalImg from '@img/legal.svg'
import legalActiveImg from '@img/legal-active.svg'
import agroImg from '@img/agro.svg'
import agroActiveImg from '@img/agro-active.svg'
import forestImg from '@img/forest.svg'
import forestActiveImg from '@img/forest-active.svg'

export default {
  name: 'dashboard',
  components: {
    'item-dashboards-subs': ItemDashboardSubs
  },
  props: ['show'],
  data () {
    return {
      selectedTab: 'map',
      hoveredItem: '',
      dashItem: false,
      ordersListOpenLocal: null
    }
  },
  watch: {
    ordersListOpen (newVal) {
      this.setBobyScrollMix(!newVal, 'ordersList')
      if (!newVal) {
        setTimeout(() => {
          this.ordersListOpenLocal = newVal
        }, 300)
      } else {
        this.ordersListOpenLocal = newVal
      }
    }
  },
  computed: {
    servicesList () {
      let _config = appStore.getters.value('config')
      if ('services' in _config) {
        return _config.services
      }
    },
    serviceName () {
      return appStore.getters.value('name')
    },
    ordersListOpen () {
      return adaptiveStore.getters.value('ordersListOpen')
    }
  },

  methods: {
    getImgPath (serviceId, active) {
      if (active === true) {
        switch (serviceId) {
          case 'eco':
            return ecoActiveImg

          case 'quarry':
            return quarryActiveImg

          case 'construction':
            return constructionActiveImg

          case 'emergency':
            return emergencyActiveImg

          case 'legal':
            return legalActiveImg

          case 'agro':
            return agroActiveImg

          case 'forest':
            return forestActiveImg

          default:
            break
        }
      } else {
        switch (serviceId) {
          case 'eco':
            return ecoImg

          case 'quarry':
            return quarryImg

          case 'construction':
            return constructionImg

          case 'emergency':
            return emergencyImg

          case 'legal':
            return legalImg

          case 'agro':
            return agroImg

          case 'forest':
            return forestImg

          default:
            break
        }
      }
      return quarryImg
    },
    mouseLeaveItem () {
      this.hoveredItem = ''
    },
    mouseOverItem (itemName) {
      this.hoveredItem = itemName
    },
    goToService (serviceId) {
      for (let i = 0; i < this.servicesList.length; i++) {
        if (this.servicesList[i].service_id === serviceId) {
          let _serviceUrl = this.servicesList[i].url
          return _serviceUrl + 'dashboard/'
        }
      }
    },
    openItem () {
      this.$eventHub.$emit('show-orders-list')
    },
    closeMenu () {
      this.dashItem = true
    },
    // hideArrow () {
    //   if (!this.dashItem) {
    //     this.$eventHub.$emit('hide-arrow')
    //   }
    // },
    selectTab (tabName) {
      if (this.selectedTab !== tabName) {
        this.selectedTab = tabName
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/varibles.scss';

.eco-color {
  background-color: $eco-color;
  color: white!important;
}
.emergency-color {
  background-color: $emergency-color;
  color: white!important;
}
.quarry-color {
  background-color: $quarry-color;
  color: white!important;
}
.construction-color {
  background-color: $construction-color;
  color: white!important;
}
.legal-color {
  background-color: $legal-color;
  color: white!important;
}
.agro-color {
  background-color: $agro-color;
  color: white!important;
}
.forest-color {
  background-color: $forest-color;
  color: white!important;
}
a {
  color: black;
  text-decoration: none;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
:focus {
  outline: 0;
}
.dashboard-item {
  position: fixed;
  z-index: 10;
  top: 74px;
  left: 0;
  width: 75px; // ширина 74 и 1px border
  height: calc(100vh - 139px); // минус высота хедера и паддингов
}
.dashboard-arrow {
  width: 0;
  height: 0;
  border-bottom: 14px solid #ffffff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  float: right;
  margin-right: 22px;
}
.dashboard-content {
  padding: 28px 12px 36px 20px;
  border-top: 1px solid #353c70;
  border-right: 1px solid #353c70;
  height: 100%;
  // width: min-content;
  border-radius: 1px;
  box-shadow: 0px 14px 38px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #2d325a;
}
.dashboard-item__arrow {
  position: absolute;
  z-index: -2;
  left: 75px;
  top: 15px
}
.dashboard-content__arrow {
  width: 29px;
  height: 49px;
  padding: 0px;
  top: 0;
  z-index: 1;
  min-width: 29px;
  margin-top: 13px;
  margin-right: -29px;
  border-radius: 4px;
  background-color: rgb(116, 159, 131);
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  font-size: 1rem;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  justify-content: center;
  text-decoration: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
}
.dashboard-content__label {
  display: inherit;
  align-items: inherit;
  font-weight: 400;
  border-bottom: 1px transparent solid;
  text-transform: none;
  justify-content: inherit;
}
.dashboard-content__label-left {
  margin-left: 0;
}
.dashboard-content__label-right {
  margin-left: 3px;
}
.dashboard-content__img {
  display: flex;
  width: 27px;
  height: 22px;
  color: #fff;
  fill: currentColor;
}
.dashboard-content__selector {
  border-radius: 17px;
  background-color: #f4f4f4;
  display: flex;
  margin-top: 12px;
  margin-bottom: 15px;
}
.dashboard-content__selector__item {
  width: 94.5px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9da6b3;
  font-size: 14px;
  cursor: pointer;
  border-radius: 17px;
}
.dashboard-content__selector__item-selected {
  color: white;
  background-color: #316fea;
}
.dashboard-content__categories {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  align-items: center;
}
.service-active-eco {
  // border: 1px $eco-color solid!important;
  border-color: $eco-color!important;
}
.service-active-emergency {
  // border: 1px $eco-color solid!important;
  border-color: $emergency-color!important;
}
.service-active-quarry {
  // border: 1px $eco-color solid!important;
  border-color: $quarry-color!important;
}
.service-active-construction {
  // border: 1px $eco-color solid!important;
  border-color: $construction-color!important;
}
.service-active-legal {
  // border: 1px $eco-color solid!important;
  border-color: $legal-color!important;
}
.service-active-agro {
  // border: 1px $eco-color solid!important;
  border-color: $agro-color!important;
}
.service-active-forest {
  // border: 1px $eco-color solid!important;
  border-color: $forest-color!important;
}
.dashboard-content__categories__item {
  width: 45px;
}
.dashboard-content__categories__item a {
  // margin-right: 13px;
  // width: 100px;
  width: 45px;
  height: 45px;
  // margin-left: -3px;
  margin-bottom: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dashboard-content__categories__item-img {
  width: 44px;
  height: 44px;
  // border: 1px #191b31 solid;
  border: 1px #353c70 solid;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: #353c70;
  background-color: #353c70;
  transition: 0.3s;
}
.item-img_cust_width img {
  width: 13px!important;
}
.dashboard-content__categories__item-img:hover {
  // background-color: #d3d3d3;
  cursor: pointer;
}
.dashboard-content__categories__item-img img {
  width: 21px;
  display: block;
  height: 27px;
}
.dashboard-content__categories__item-text {
  text-align: center;
  // width: 62px;
  width: min-content;
  margin-top: 4px;
  color: #383838;
  font-size: 14px;
}

@media (min-width: 768px) and (max-width: 960px) {
  .dashboard-item {
    top: 74px;
  }
}

@media (min-width: 426px) and (max-width: 768px) {
  // .dashboard-item__arrow {
  //   left: 0;
  //   top: 16px;
  // }
  .dashboard-item {
    top: 68px;
    height: calc(100vh - 133px);
  }
  .dashboard-content {
    overflow-y: auto;
  }
}

@media (min-width: 320px) and (max-width: 768px) {
  // .dashboard-item {
  //   display: flex;
  //   width: 100%;
  // }
  // .dashboard-content {
  //   display: flex;
  //   position: fixed;
  //   width: 100%;
  //   height: 90px;
  //   flex-direction: row;
  //   bottom: 0;
  //   padding: 0;
  // }
  // .dashboard-content__categories {
  //   display: flex;
  //   width: 100%;
  //   flex-direction: row;
  //   justify-content: space-around;
  // }
}
@media (min-width: 320px) and (max-width: 425px) {
  .dashboard-item {
    display: flex;
    width: 0;
    // display: none;
  }
  .dashboard-content {
    // display: flex;
    display: none;
    position: fixed;
    width: 100%;
    height: 70px;
    flex-direction: row;
    bottom: 0;
    padding: 0;
  }
  .dashboard-content__categories {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
  }
  .dashboard-item__arrow {
    left: 0;
    top: -10px;
    display: none;
  }
  .dashboard-content__categories__item a {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/headerItems/ItemDashboards.vue